module.exports = __webpack_public_path__ + "img/icon-white-11.beb9de94.svg";